
export default {
    // mode: "history",
    base: process.env.BASE_URL
};
